export const isDateWithinRange = (date, ranges) => {
  if (!date?.length || !ranges?.length) {
    return false;
  }

  if (typeof ranges[0] === 'string') {
    return ranges.includes(date);
  }

  for (const range of ranges) {
    if (range.includes(date)) {
      return true;
    }
  }

  return false;
};

export const getRangeDays = (start, end) => {
  const arr = [];
  let currentDate = new Date(start);
  const endDate = new Date(end);

  while (currentDate <= endDate) {
    arr.push(currentDate.toISOString().slice(0, 10));
    currentDate = new Date(currentDate);
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return arr;
};

export const getWeekday = (date) => {
  const weekday = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  const parsedDate = new Date(date.replace(/-/g, '/'));

  return weekday[parsedDate.getDay()];
};

export const isWeekendCheckoutAvailable = (date, weekendCheckoutFlag) => {
  const day = getWeekday(date);
  return !(['saturday', 'sunday'].includes(day) && !weekendCheckoutFlag);
};

export const addOrSubractDays = (date, number) => {
  if (!date) {
    return;
  }

  const parsedDate = new Date(date.replace(/-/g, '/'));
  const resultDate = new Date(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate() + number);

  return resultDate.toISOString().slice(0, 10);
};

export const getMaxDate = (dates) => {
  if (!dates) {
    return;
  }

  const parsedDates = dates.map(Date.parse);
  const maxDate = new Date(Math.max(...parsedDates));

  return maxDate.toISOString().slice(0, 10);
};

export const getMinDate = (dates) => {
  if (!dates) {
    return;
  }

  const parsedDates = dates.map(Date.parse);
  const minDate = new Date(Math.min(...parsedDates));

  return minDate.toISOString().slice(0, 10);
};

export const getRange = (startDate, endDate, type) => {
  const start = moment(startDate);
  const diff = moment(endDate).diff(start, type);

  return Array.from({ length: diff + 1 }, (_, i) => start.clone().add(i, type).format('YYYY-MM-DD'));
};

export const formatDateForRails = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};
